;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Button, ModalBody, ModalFooter } from 'reactstrap';
import UndrawAdvancedPersonalization from '../../svg/UndrawAdvancedPersonalization';
import ProfileModalListItem from './ProfileModalListItem';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

type Props = {
  toggle: () => void;
  next: () => void;
  dictionary: Partial<Dictionaries>;
};
function ProfileModalIntro({ toggle, next, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <>
      <ModalBody>
        <div className="py-4">
          <h2>{formatMessage({ id: 'complete-profile' })}</h2>
          <span className="d-block mb-3">{formatMessage({ id: 'complete-profile-find-job' })}</span>
          <div className="bg-light p-3 py-5">
            <div className="py-4">
              <UndrawAdvancedPersonalization className="d-block mx-auto" />
            </div>
            <span className="d-block mb-4">{formatMessage({ id: 'list_advantages' })}</span>

            <ul className="unstyled ms-3">
              <ProfileModalListItem text={formatMessage({ id: 'tailored_jobmatches' })} />
              <ProfileModalListItem text={formatMessage({ id: 'stay_up_to_date' })} />
              <ProfileModalListItem text={capitalizeFirstLetter(formatMessage({ id: 'mysynergie_favorites' }))} />
              <ProfileModalListItem text={formatMessage({ id: 'save_searches' })} />
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="w-100" onClick={() => next()}>
          {formatMessage({ id: 'do_it_now' })}
        </Button>

        <Button color="white" className="mt-3 mx-auto d-block" onClick={() => toggle()}>
          {formatMessage({ id: 'do_it_later' })}
        </Button>
      </ModalFooter>
    </>
  );
}

export default ProfileModalIntro;
